import styled from "styled-components";

export const UploadDocumentWrapper = styled.div`
  margin: 10px 100px;
`;

export const TitleAboveInput = styled.div`
  color: ${({ theme }) => {
    return theme.colors.darkgrey;
  }};
  text-align: left;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
`;

export const FileInputWrapper = styled.div`
  width: 170px;
  margin-top: 10px;
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
  border: 1px solid
    ${({ theme }) => {
      return theme.colors.green;
    }};
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  text-align: center;
  border-radius: 40px;
  &:hover {
    cursor: pointer;
  }
  padding: 5px 10px;
  /* & input[type="file"]::-webkit-file-upload-button {
    color: ${({ theme }) => {
    return theme.colors.green;
  }};
    border: 1px solid
      ${({ theme }) => {
    return theme.colors.green;
  }};
    border-radius: 15px;
    background-color: white;
    padding: 5px 20px;
    margin-right: 15px;
  } */
`;

export const BtnWrapper = styled.div`
  margin-top: 10px;
  text-align: right;
`;

export const UploadFileDetailsWrapper = styled.div`
  display: flex;
`;

export const FileWrapper = styled.div`
  margin: 10px 0px 0px 10px;
`;

export const CloseIconWrapper = styled.div`
  margin-top: 20px;
  color: #ea0000;
`;
